import { render, staticRenderFns } from "./TodayNew.vue?vue&type=template&id=52c1f116&scoped=true&"
import script from "./TodayNew.vue?vue&type=script&lang=js&"
export * from "./TodayNew.vue?vue&type=script&lang=js&"
import style0 from "./TodayNew.vue?vue&type=style&index=0&id=52c1f116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1f116",
  null
  
)

export default component.exports